import { z } from 'zod';
/**
 * LocalDate — a calendar day (year/month/day) with no timezone.
 *
 * Wire format: `YYYY-MM-DD` (ISO-8601 calendar date).
 * Regex: `^\d{4}-\d{2}-\d{2}$`
 *
 * Validated at two levels:
 *   1. Regex rejects structurally-malformed strings.
 *   2. `.refine(validateCalendarDate, ...)` rejects structurally-valid but
 *      calendar-impossible values (e.g. 2023-02-29, 2026-13-01, 2026-04-31).
 *
 * Year 0000 is rejected — JS practical ISO year range starts at 0001.
 */
function isLeapYear(year) {
    // Gregorian rule: divisible by 4, but not by 100 unless divisible by 400.
    return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
}
function daysInMonth(year, month) {
    // month is 1-12
    switch (month) {
        case 1:
        case 3:
        case 5:
        case 7:
        case 8:
        case 10:
        case 12:
            return 31;
        case 4:
        case 6:
        case 9:
        case 11:
            return 30;
        case 2:
            return isLeapYear(year) ? 29 : 28;
        default:
            return 0;
    }
}
function validateCalendarDate(value) {
    // Regex is guaranteed to have matched by the time we run refine;
    // still, parse defensively.
    const match = /^(\d{4})-(\d{2})-(\d{2})$/.exec(value);
    if (!match)
        return false;
    const year = Number(match[1]);
    const month = Number(match[2]);
    const day = Number(match[3]);
    if (year < 1 || year > 9999)
        return false;
    if (month < 1 || month > 12)
        return false;
    const maxDay = daysInMonth(year, month);
    if (day < 1 || day > maxDay)
        return false;
    return true;
}
export const LocalDateSchema = z
    .string()
    .regex(/^\d{4}-\d{2}-\d{2}$/, 'must be YYYY-MM-DD')
    .refine(validateCalendarDate, 'must be a real calendar date')
    .brand();
//# sourceMappingURL=local-date.js.map